import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [
		{
			name: "home",
			path: "/",
			component: () => import("@/pages/Home/home.vue"),
		},
		{
			name: "info1",
			path: "/info/page1/:headId",
			component: () => import("@/pages/Info/page1.vue"),
		},
		{
			name: "info2",
			path: "/info/page2/:headId",
			component: () => import("@/pages/Info/page2.vue"),
		},
		{
			name: "info3",
			path: "/info/page3/:headId",
			component: () => import("@/pages/Info/page3.vue"),
		},
		{
			name: "info4",
			path: "/info/page4/:headId",
			component: () => import("@/pages/Info/page4.vue"),
		},
		{
			name: "info5",
			path: "/info/page5/:headId",
			component: () => import("@/pages/Info/page5.vue"),
		},
		{
			name: "info6",
			path: "/info/page6/:headId",
			component: () => import("@/pages/Info/page6.vue"),
		},
		{
			name: "info7",
			path: "/info/page7/:headId",
			component: () => import("@/pages/Info/page7.vue"),
		},
		{
			name: "info8",
			path: "/info/page8/:headId",
			component: () => import("@/pages/Info/page8.vue"),
		},
		{
			name: "media",
			path: "/media/:headId",
			component: () => import("@/pages/Media/media.vue"),
		},
		{
			name: "problem",
			path: "/problem/:headId",
			component: () => import("@/pages/Problem/problem.vue"),
		},
		{
			name: "story",
			path: "/story/:headId",
			component: () => import("@/pages/Story/story.vue"),
		},
		{
			name: "login",
			path: "/login",
			component: () => import("@/pages/Login/login.vue"),
		},
	],
});
